import type { UsagePeriod } from '@/routes/usage/types'

export const USAGE_TYPE_LABELS: Record<string, string> = {
  appCompute: 'App compute',
  appStorage: 'App persistent storage',
  appBuild: 'App build time',
  appBandwidth: 'App bandwidth',
  staticSiteBuild: 'Static site build time',
  staticSiteBandwidth: 'Static site bandwidth',
  db: 'Database',
  objectStorage: 'Object storage',
  loadBalancer: 'Load balancer',
  loadBalancerBandwidth: 'Load balancer bandwidth',
}

export const USAGE_TYPE_COLORS: Record<string, string> = {
  appCompute: 'var(--chart-1)',
  appStorage: 'var(--chart-2)',
  appBuild: 'var(--chart-3)',
  appBandwidth: 'var(--chart-4)',
  db: 'var(--chart-5)',
  staticSiteBuild: 'var(--chart-6)',
  staticSiteBandwidth: 'var(--chart-7)',
  objectStorage: 'var(--chart-8)',
  loadBalancer: 'var(--chart-9)',
  loadBalancerBandwidth: 'var(--chart-10)',
}

export const PERIOD_OPTIONS: { value: UsagePeriod; label: string }[] = [
  { value: 'current', label: 'Current period' },
  { value: 'previous', label: 'Previous period' },
]

export const USAGE_TYPE_TO_SERVICE_TYPE: Record<string, string> = {
  appCompute: 'app',
  appStorage: 'app',
  appBuild: 'app',
  appBandwidth: 'app',
  db: 'db',
  staticSiteBuild: 'staticSite',
  staticSiteBandwidth: 'staticSite',
  objectStorage: 'objectStorage',
  loadBalancer: 'loadBalancer',
  loadBalancerBandwidth: 'loadBalancer',
}

export const getUsageTypeLabel = (type: string): string => {
  return USAGE_TYPE_LABELS[type] ?? type
}

export const getUsageTypeColor = (type: string): string => {
  return USAGE_TYPE_COLORS[type] ?? `var(--chart-${(type.length % 10) + 1})`
}
